import { SectionHeading } from '../components/SectionHeading';
import { Reveal } from '../components/Reveal';
import { valueProps } from '../data/content';

export const ValueProps = () => (
  <section data-testid="value-props-section" className="bg-paper">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <SectionHeading
        chapter="01"
        eyebrow="Why TheBigHub"
        title="One Hub. Many Solutions. Maximum Impact."
        copy="From building your online presence to attracting customers, developing digital products, and equipping people with practical digital skills, TheBigHub brings powerful solutions together under one roof."
      />
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {valueProps.map((v, i) => {
          const Icon = v.icon;
          return (
            <Reveal key={v.title} delay={i * 0.09} className="h-full">
              <div
                data-testid={`value-prop-${i + 1}`}
                className="card-lift group h-full rounded-2xl border-2 border-forest bg-forest p-7"
              >
                <span className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-white/15 text-goldlight transition-colors duration-500 group-hover:bg-white group-hover:text-forest">
                  <Icon size={22} strokeWidth={1.8} />
                </span>
                <h3 className="font-display text-lg font-bold text-white">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white">{v.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
